/*
  Funnel landing pages: tell Kaching Popup which product this page sells, and keep its popups one-time only.

  Kaching Popup only shows a popup set to "specific products" when the current page's product is in
  its list, and it reads that product from #kaching-popup-v2-config, which its app embed fills in only
  on product pages (null on a page). So the add-to-cart upsell showed on the PDP but never after Add to
  Cart on a landing page.

  Subscriptions are offered on product pages only (snippets/subscription-guard.liquid), so the popups'
  selling-plan pickers are hidden here; without the picker the popup adds its product as a one-time purchase.

  Loaded with `defer` by snippets/lp-kaching-popup-product.liquid. Deferred scripts run in document
  order, and this tag sits above the app embeds at the end of <body>, so it edits the config before
  Kaching's own deferred kaching-popup-block.js reads it.
*/
(function () {
  var me = document.currentScript;
  var el = document.getElementById('kaching-popup-v2-config');
  if (!me || !el) return;
  try {
    var cfg = JSON.parse(el.textContent || '{}');
    var pid = Number(me.getAttribute('data-product-id'));
    if (pid && cfg.productId == null) {
      cfg.productId = pid;
      var img = me.getAttribute('data-product-image');
      if (img && !cfg.productImageUrl) cfg.productImageUrl = img;
      var cols = (me.getAttribute('data-collection-ids') || '').split(',').filter(Boolean).map(Number);
      if (cols.length && !(cfg.collectionIds && cfg.collectionIds.length)) cfg.collectionIds = cols;
    }
    (function hidePlans(o) {
      if (Array.isArray(o)) { o.forEach(hidePlans); return; }
      if (!o || typeof o !== 'object') return;
      if (o.type === 'productSellingPlans') o.hidden = true;
      for (var k in o) hidePlans(o[k]);
    })(cfg.popups);
    el.textContent = JSON.stringify(cfg);
  } catch (e) {}
})();
